export enum DeliveryStatus {
  Wait = "WAIT",
  Matched = "MATCHED",
  Start = "START",
  PickUp = "PICK_UP",
  Ship = "SHIP",
  DropOff = "DROP_OFF",
}

export const DeliveryStatusLabels: { [key in DeliveryStatus]: string } = {
  [DeliveryStatus.Wait]: "배정대기",
  [DeliveryStatus.Matched]: "배정완료",
  [DeliveryStatus.Start]: "픽업가는중",
  [DeliveryStatus.PickUp]: "픽업완료",
  [DeliveryStatus.Ship]: "하차가는중",
  [DeliveryStatus.DropOff]: "배송완료",
};
